import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const ConfirmDelete = ({ target, label, onCancel, onConfirm, children, title, description, action = "Delete" }) => (
  <AlertDialog open={!!target} onOpenChange={(o) => !o && onCancel()}>
    <AlertDialogContent data-testid="confirm-delete-dialog" className="border-white/10 bg-[#0D111A]">
      <AlertDialogHeader>
        <AlertDialogTitle className="text-white">{title || `Delete ${label}?`}</AlertDialogTitle>
        <AlertDialogDescription>{description || "This permanently removes it. This can't be undone."}</AlertDialogDescription>
      </AlertDialogHeader>
      {children}
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="confirm-delete-cancel" className="border-white/10 bg-transparent text-slate-200">Cancel</AlertDialogCancel>
        <AlertDialogAction data-testid="confirm-delete-confirm" onClick={onConfirm} className="bg-red-500 text-white hover:bg-red-600">{action}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const FormField = ({ id, label, error, children }) => (
  <div>
    <label htmlFor={id} className="mb-1.5 block text-sm text-slate-300">{label}</label>
    {children}
    {error && <p data-testid={`${id}-error`} className="mt-1 text-xs text-red-400">{error}</p>}
  </div>
);

export const adminInput = (err) =>
  `w-full rounded-lg border bg-[#07090E] px-3 py-2.5 text-sm text-white outline-none transition-colors focus:border-cyan-400/70 ${err ? "border-red-500/70" : "border-white/10"}`;
